import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';

export default function RefreshButton({ children = 'Refresh', ...props }) {
    return (
        <Button
            variant="outlined"
            size="small"
            startIcon={<RefreshIcon />}
            {...props}
        >
            {children}
        </Button>
    );
}
